import { Link } from "react-router-dom";

import {
    FOUNDER_EMAIL,
    HELP_EMAIL,
    PHONE_DISPLAY,
} from "@/constants/links";

export default function Footer() {
    return (
        <footer className="core-footer" data-testid="footer">
            <div className="core-container">
                <div className="core-footer-grid">
                    <div>
                        <div className="brand-logo">
                            <img
                                className="brand-logo-mark"
                                src="/img/core-logo.png"
                                alt="C-ORE"
                                width="108"
                                height="24"
                            />
                            <span className="accent">C-Suites</span>
                        </div>
                        <p className="core-footer-tag">
                            C-Suite intelligence for businesses across the
                            globe.
                        </p>
                        <ul>
                            <li>
                                <a href={`mailto:${HELP_EMAIL}`}>
                                    {HELP_EMAIL}
                                </a>
                            </li>
                            <li>
                                <a href="tel:+919371880369">{PHONE_DISPLAY}</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h5>Product</h5>
                        <ul>
                            <li>
                                <a href="/#features">Features</a>
                            </li>
                            <li>
                                <a href="/#pricing">Pricing</a>
                            </li>
                            <li>
                                <a href="/#how-it-works">How it works</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h5>Company</h5>
                        <ul>
                            <li>
                                <a href="/#problem">About</a>
                            </li>
                            <li>
                                <a href="/#contact">Contact</a>
                            </li>
                            <li>
                                <a href={`mailto:${FOUNDER_EMAIL}`}>
                                    CA Partners
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h5>Legal</h5>
                        <ul>
                            <li>
                                <Link to="/privacy" data-testid="footer-privacy-link">
                                    Privacy
                                </Link>
                            </li>
                            <li>
                                <Link to="/terms" data-testid="footer-terms-link">
                                    Terms
                                </Link>
                            </li>
                            <li>
                                <Link to="/security" data-testid="footer-security-link">
                                    Security
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="core-footer-bottom">
                    <div className="core-made-in">
                        Made with{" "}
                        <span className="core-heart" aria-label="love">
                            ❤
                        </span>{" "}
                        in <strong>India</strong> · Built for the world.
                    </div>
                    © 2026 Core Billion — India. All rights reserved.
                    <br />
                    boardroom.c-ore.in · {HELP_EMAIL} · {PHONE_DISPLAY}
                </div>
            </div>
        </footer>
    );
}
